module.exports = __webpack_public_path__ + "static/media/members.4306d4fb.svg";